import React from 'react';
import './BlueprintPanelFooter.scss'

export default class BlueprintPanelFooter extends React.Component {
  constructor(props) {
    super(props);

    this.hasBack = typeof this.props.onBack === 'function';
    this.hasNext = typeof this.props.onNext === 'function';
    this.hasSubmit = typeof this.props.onSubmit === 'function';
  }


  render() {
    return (
        <div className="container-fluid clearfix BlueprintPanelFooter">
          {
            this.hasBack ?
                (<button className="btn btn-dark"
                         disabled={this.props.submitting}
                         onClick={this.props.onBack}>
                  Back
                </button>) : null
          }
          {
            this.hasNext ?
                (<button className="btn btn-purple pull-right"
                         disabled={this.props.submitting}
                         onClick={this.props.onNext}>
                  {this.props.submitting ? 'Submitting...' : 'Save and Next'}
                </button>) : null
          }
          {
            this.hasSubmit ?
                (<button className="btn btn-purple pull-right"
                         disabled={this.props.submitting}
                         onClick={this.props.onSubmit}>
                  {this.props.submitting ? 'Submitting...' : 'Submit'}
                </button>) : null
          }
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/blocks/BlueprintPanelFooter.js